import React, { Component } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';
import CommonPreviewFileModal from './components/CommonPreviewFileModal';

import CommonTokenExpired from './components/CommonTokenExpired';

/** withRouter */
import withRouter from "./components/withRouter"

/** start individual component */
import InputRegister from './inputs/InputRegister';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/RegisterState';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `register`;
const URL = `api/master/${TABLE}`;
const CREATEURL = `public/view/`;

class Register extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadMasterbase();
    }

    loadMasterbase = async () => {
        let sets = [
            {key: "benefits", filter: [{field: "status", value: "0"}]},
            {key: "position", filter: [{field: "status", value: "0"}]},
            {key: "target_industries", filter: [{field: "status", value: "0"}]},
            
            {key: "province", filter: [{field: "status", value: "0"}]}, 
            {key: "district", filter: [{field: "status", value: "0"}]}, 
            {key: "subdistrict", filter: [{field: "status", value: "0"}]},
        ]; 
        await Actions.loadMasterbase(this.updateState, sets, 'public');
    }

    submitData = async () => {
        const { Action, Inputs, DataTable, Operation } = this.state;

        const newInputs = { ...Inputs };

        const today = new Date().toISOString().split('T')[0];
        newInputs.register_date.value = today;
        newInputs.status.value = 0;

        await Actions.submitData(
            this.updateState,
            Operation?.SubmitURL || `${CREATEURL}register`,
            Action.Mode, 
            fn.getInputForm({ ...newInputs }),
            this.loadDataTable
        );
    }
    // swapURL = (id) => {
    //     if(e.target.value === '1') {
    //     return `${CREATEURL}`;
    //     }
    //     console.log(e);                        
    // }

    componentDidMount = async () => {
        await this.initialize(); 
        Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true)
    }

    componentDidUpdate = async () => {}    

    render = () => {

        let { Action, Searchs, DataTable, Inputs, InputGroup, Masterbase, Deletes, Operation, Token } = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <InputRegister 
                    URL={URL}
                    
                    App={AppProps}

                    Action={Action}
                    Inputs={Inputs}
                    InputGroup={InputGroup}
                    Masterbase={Masterbase}
                    Operation={Operation}

                    onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                    onInputChange={(e, element) => {

                        Actions.handleInputChange(this.updateState, element, e);

                        if(e.target.name === 'Inputs_register_type'){

                            setTimeout(() => {

                                let submitURL = CREATEURL;

                                /** clone ใหม่ */
                                let updatedInputs = {
                                    ...this.state.Inputs
                                };

                                /** reset default */
                                updatedInputs.username.validator.required = true;
                                updatedInputs.password.validator.required = true;
                                updatedInputs.contact.validator.required = true;
                                updatedInputs.email.validator.required = true;

                                updatedInputs.operator_name.validator.required = false;
                                updatedInputs.executive.validator.required = false;
                                updatedInputs.coordinator_name.validator.required = false;
                                updatedInputs.coordinator_phone_number.validator.required = false;
                                updatedInputs.enterprise_contact.validator.required = false;
                                updatedInputs.location.validator.required = false;
                                updatedInputs.province_id.validator.required = false;
                                updatedInputs.district_id.validator.required = false;
                                updatedInputs.subdistrict_id.validator.required = false;

                                switch(e.target.value){
                                    
                                    case '0':
                                        submitURL = `${CREATEURL}register`;
                                    break;

                                    /** สมัครเข้าใช้งานผู้ประกอบการ */
                                    case '1':

                                        submitURL = `${CREATEURL}register-enterprise`;

                                        updatedInputs.fullname.validator.required = false;

                                        updatedInputs.operator_name.validator.required = true;
                                        updatedInputs.executive.validator.required = true;
                                        updatedInputs.coordinator_name.validator.required = true;
                                        updatedInputs.coordinator_phone_number.validator.required = true;
                                        updatedInputs.enterprise_contact.validator.required = true;

                                    break;

                                    /** default */
                                    default:

                                        submitURL = `${CREATEURL}register`;

                                        updatedInputs.fullname.validator.required = true;

                                    break;
                                }

                                Actions.updateState(this.updateState, 'Inputs', updatedInputs);

                                Actions.updateState(this.updateState, 'Operation', {
                                    ...this.state.Operation,
                                    SubmitURL: submitURL
                                });

                                console.log('submitURL => ', submitURL);

                            }, 0);
                        }
                    }}

                    onCloseAlert={(e) => { Actions.handleCloseAlert(this.updateState, 'Alert', e); }}
                    onSubmit={async (e) => { await this.submitData()}}
                    
                    onDiscardSubmit={(e) => { Actions.handleDiscardInputs(this.updateState, 'Inputs'); }}
                    onClose={(e) => {
                            Actions.handleDiscardInputs(this.updateState, 'Inputs');
                            Actions.handleCloseInputForm(this.updateState, 'OffCanvas')
                        }
                    }
                />
            </>
        )
    }
}

export default withRouter(Register);